import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import mohLogo from "../../assets/images/MOH_LOGO.png";
import useAppStore from "../../store";
import { Link } from "react-router-dom";
import { fsnrlRoles, nmrlRoles, nicRoles, gmslRoles, nobrlRoles, nhrlRoles, anyDashboardRoles, adminRoles, nvrlRoles, coeRoles } from "../../constants/roles";

function Sidenav({ color }) {
  const user = useAppStore((state) => state.user);
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const profile = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  return (
    <>
      <Link to="/home">
        <div className="brand">
          <img src={mohLogo} alt="" />
          <span style={{ color: 'black' }}>NPHL Dashboards</span>
        </div>
      </Link>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/home">
            <span
              className="icon"
              style={{
                background: page === "home" ? color : "",
              }}
            >
              {dashboard}
            </span>
            <span className="label">Home</span>
          </NavLink>
        </Menu.Item>

        {user?.roles.some(v => anyDashboardRoles.includes(v)) &&
          <Menu.Item key="1.5" className="menu-item-header">
            Dashboards
          </Menu.Item>
        }
        {/* FSNRL */}
        {user?.roles.some(v => fsnrlRoles.includes(v)) &&
          <Menu.Item key="1.75">
            <NavLink to="/public/fsnrl">
              <span
                className="icon"
                style={{
                  background: page === "old" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">FSNRL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* NMRL */}
        {user?.roles.some(v => nmrlRoles.includes(v)) &&
          <Menu.Item key="2">
            <NavLink to="/public/nmrl">
              <span
                className="icon"
                style={{
                  background: page === "tables" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">NMRL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* NIC */}
        {user?.roles.some(v => nicRoles.includes(v)) &&
          <Menu.Item key="3">
            <NavLink to="/public/nic">
              <span
                className="icon"
                style={{
                  background: page === "billing" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">NIC</span>
            </NavLink>
          </Menu.Item>
        }

        {/* GMSL */}
        {user?.roles.some(v => gmslRoles.includes(v)) &&
          <Menu.Item key="4">
            <NavLink to="/public/gmsl">
              <span
                className="icon"
                style={{
                  background: page === "rtl" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">GMSL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* NOBRL */}
        {user?.roles.some(v => nobrlRoles.includes(v)) &&
          <Menu.Item key="5">
            <NavLink to="/public/nobrl">
              <span
                className="icon"
                style={{
                  background: page === "rtl" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">NOBRL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* NHRL */}
        {user?.roles.some(v => nhrlRoles.includes(v)) &&
          <Menu.Item key="6">
            <NavLink to="/public/nhrl">
              <span
                className="icon"
                style={{
                  background: page === "rtl" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">NHRL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* NVRL */}
        {user?.roles.some(v => nvrlRoles.includes(v)) &&
          <Menu.Item key="6">
            <NavLink to="/public/nvrl">
              <span
                className="icon"
                style={{
                  background: page === "rtl" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">NVRL</span>
            </NavLink>
          </Menu.Item>
        }

        {/* COE */}
        {user?.roles.some(v => coeRoles.includes(v)) &&
          <Menu.Item key="6">
            <NavLink to="/public/coe">
              <span
                className="icon"
                style={{
                  background: page === "rtl" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">COE</span>
            </NavLink>
          </Menu.Item>
        }

        <Menu.Item key="6.5" className="menu-item-header">
          Other Pages
        </Menu.Item>

        <Menu.Item key="7">
          <NavLink to="/about">
            <span
              className="icon"
              style={{
                background: page === "about" ? color : "",
              }}
            >
              {profile}
            </span>
            <span className="label">About</span>
          </NavLink>
        </Menu.Item>

        {user?.roles.some(v => adminRoles.includes(v)) &&
          <>
            <Menu.Item key="7.5" className="menu-item-header">
              Admin
            </Menu.Item>

            <Menu.Item key="8">
              <NavLink to="/admin">
                <span
                  className="icon"
                  style={{
                    background: page === "admin" ? color : "",
                  }}
                >
                  {profile}
                </span>
                <span className="label">Admin</span>
              </NavLink>
            </Menu.Item>

            <Menu.Item key="9">
              <NavLink to="/public/monitoring">
                <span
                  className="icon"
                  style={{
                    background: page === "admin" ? color : "",
                  }}
                >
                  {profile}
                </span>
                <span className="label">Monitoring</span>
              </NavLink>
            </Menu.Item>
          </>
        }
      </Menu>
      <div className="aside-footer">
        <span>Powered by</span>
        <div
          onClick={() => window.open("https://www.aphl.org/", "_blank")}
          className="footer-box"
          style={{
            // backgroundImage: aphlLogo,
            marginLeft: "2rem",
            marginBottom: "0"
          }}
        >
          {/* <img alt="example" src={aphlLogo} /> */}
        </div>
      </div>
    </>
  );
}

export default Sidenav;
